import React, { CSSProperties, useCallback } from 'react';

import cn from 'classnames';

import styles from './Spinner.module.scss';

interface SpinnerProps {
  main?: boolean;
  local?: boolean;
  overlayClassName?: string;
  icon?: boolean;
  spinnerStyle?: CSSProperties;
}

const Spinner = ({
  main = false,
  local = false,
  overlayClassName,
  icon = false,
  spinnerStyle = {},
}: SpinnerProps) => {
  const syncAnimationPhase = useCallback((element: HTMLDivElement | null) => {
    if (!element) return;

    // Anchor every new animation to the document timeline. Existing DOM nodes
    // keep running natively, while remounted nodes resume at the same exact time.
    const timelineTime = document.timeline?.currentTime;
    if (timelineTime == null) return;

    element.getAnimations?.({ subtree: true }).forEach((animation) => {
      animation.currentTime = timelineTime;
    });
  }, []);

  if (main) {
    return (
      <div className={cn(styles.loadingWrapper, overlayClassName)}>
        <div className={styles.loadingText}>LOADING</div>
        <div
          ref={syncAnimationPhase}
          className={styles.loadingContent}
          style={spinnerStyle}
        ></div>
      </div>
    );
  }

  if (icon) {
    return (
      <div ref={syncAnimationPhase} className={styles.icon} style={spinnerStyle}></div>
    );
  }
  return (
    <div className={cn(styles.wrapper, local && styles.local, overlayClassName)}>
      <div ref={syncAnimationPhase} className={styles.spinner} style={spinnerStyle}></div>
    </div>
  );
};

export default Spinner;
